import { render } from "./previous.vue?vue&type=template&id=768a47b6"
import script from "./previous.vue?vue&type=script&lang=js"
export * from "./previous.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__